import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import actionReducer from './action';
import authReducer from './auth';
import exampleReducer from './example';
import socketReducer from './socket';
import systemReducer from './system';

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: {
    example: exampleReducer,
    auth: authReducer,
    socket: socketReducer,
    system: systemReducer,
    action: actionReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
